<script lang="ts">
export interface Props {
  label?: string,
  required?: boolean,
  fontSize?: number,
  bold?: boolean,
  hint?: string,
  hintIsHtml?: boolean,
  disabled?: boolean,
  truncate?: boolean,
  customClass?: string,
}
</script>

<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(defineProps<Props>(), {
  label: '',
  required: false,
  fontSize: 14,
  bold: false,
  disabled: false,
  hint: '',
  hintIsHtml: false,
  truncate: false,
  customClass: '',
});

const fontStyle = computed(() => {
  return {
    fontSize: `${props.fontSize}px`,
    lineHeight: `${props.fontSize}px`,
  };
});
</script>

<template>
  <div class="t:flex t:items-center">
    <span
      :class="[
        'ui-label',
        {'ui-label_bold': bold},
        {'ui-label_required': required},
        {'ui-label_disabled': disabled},
        {'t:truncate': truncate},
        customClass
      ]"
      :style="fontStyle"
      v-html="label"
    />
    <UiTooltip
      v-if="hint"
      :tooltip="hint"
      :is-html="hintIsHtml"
    >
      <UiIcon
        name="question-circle"
        class="t:ml-4 t:cursor-pointer"
        color="var(--text-body-tertiary)"
        :size="14"
      />
    </UiTooltip>
  </div>
</template>

<style lang="scss">
.ui-label {
  color: var(--text-body);
  display: block;
  transition: all .3s ease 0s;

  &_disabled{
    opacity: .5;
  }
  &_bold{
    font-weight: 500;
  }
  &_required:after{
    margin-left: 4px;
    content: "*";
    color: var(--text-negative);
  }

}
</style>
